/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  curb_lane_width: '',
  special_considerations: [],
  freight_tier: '',
  land_use_context: '',
  curb_lane_width_adjustments: [],
  scores: {}
}

const freight = createSlice({
  name: 'freight',
  initialState,
  reducers: {
    setFreightInputs(state, action) {
      const { field, value } = action.payload
      if (
        field === 'special_considerations' ||
        field === 'curb_lane_width_adjustments'
      ) {
        // If filed already includes value remove it / add
        state[field] = state[field].includes(value)
          ? state[field].filter((input) => input !== value)
          : [...state[field], value]
      } else {
        state[field] = value
      }
    },
    setFreightScores(state, action) {
      const { field, value } = action.payload
      state.scores = { ...state.scores, [field]: value }
    },
    resetFreightInputs(state) {
      return initialState
    },
    setAllFreightInputs(state, action) {
      return action.payload
    }
  }
})

export const {
  setFreightInputs,
  setFreightScores,
  resetFreightInputs,
  setAllFreightInputs
} = freight.actions
export default freight.reducer
